<form class="room-invite">
    {[ if (o.error_message) { ]}
        <span class="error">{{{o.error_message}}}</span>
    {[ } ]}
    <input class="form-control invited-contact" placeholder="{{{o.label_invitation}}}" type="text"/>
</form>
